<template>
  <Layout>
    <div class="row mb-4" style="align-items: center">
      <div class="col-9">
        <h4 class="mb-0 font-size-18">{{ title }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8">
                <h4 class="card-title mb-4" style="display: flex; gap: 10px; align-items: center">Logs
                  <span>
                    <button type="button" @click="goBack()" class="link btn btn-outline-dark btn-sm ml-10">Voltar</button>
                  </span>
                </h4>
              </div>
              <div class="col-sm-4">
                <div class="search-box mr-2 mb-2">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Pesquise por Nome ou Telefone e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th width="5%">#</th>
                    <th width="10%">Data</th>
                    <th width="40%">Participante</th>
                    <th width="40%">Detalhes</th>
                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, idx) in contacts" :key="idx">
                    <td>{{ `# ${idx + 1}` }}</td>
                    <td>{{ list.created_at }}</td>
                    <td>{{ list.participant.data.name }}</td>
                    <td>{{ list.detail }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/components/layout/vertical'
import appConfig from '@/app.config'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout
  },
  name: 'task-change-status-details',
  page: {
    title: 'Tarefas - Logs da Mudança de Status',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      timeout: 60000,
      search: '',
      params: {
        include: 'logs'
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      title: 'Logs da Tarefa -'
    }
  },
  mounted () {
    this.loadItem()
    this.loading = false
  },
  computed: {
    ...mapState('taskChangeStatus', { data: 'task' }),
    ...mapState('taskChangeStatus', ['contacts', 'paginationC']),
    rows () {
      return this.paginationC.total
    }
  },
  methods: {
    ...mapActions('taskChangeStatus', {
      getTask: 'show',
      getContacts: 'getContacts'
    }),
    goBack () {
      this.$router.push({
        name: 'setting-tasks'
      })
    },
    loadItem () {
      if (this.$route.params.id !== undefined) {
        let loader = this.$loading.show()
        this.getTask(this.$route.params.id)
          .then(() => {
            this.title += ' ' + this.data.name
            this.task = this.data
          }).then(() => {
            loader.hide()
            this.updateList()
          })
      }
    },
    getReport () {
      let params = {
        include: 'participant',
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      let loader = this.$loading.show()
      this.params = params
      this.getContacts({ id: this.task.id, params: this.params }).then(() => {
        this.totalRows = this.paginationC.total
        this.currentPage = this.paginationC.current_page
        loader.hide()
      }).catch(error => {
        loader.hide()
        console.log(error)
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport()
    },
    updateList () {
      this.getReport()
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
